/**
 * Header functionality
 * Manages mobile menu, desktop dropdowns, scroll behavior, and navigation
 */

export default function Header() {
    const header = document.getElementById('header');
    const mobileMenuButton = document.querySelector('.mobile-menu-button');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileMenuClose = document.querySelector('.mobile-menu-close');
    const mobileMenuOverlay = document.querySelector('.header__mobile-menu-overlay');
    const mobileDropdownToggles = document.querySelectorAll('.mobile-dropdown-toggle');
    const desktopDropdownToggles = document.querySelectorAll('.desktop-dropdown-toggle');
    const institucionalTrigger = document.querySelector('[data-institucional-trigger]');
    const institucionalDropdown = document.getElementById('institucional-dropdown');
    const produtosTrigger = document.querySelector('[data-produtos-trigger]');
    const produtosDropdown = document.getElementById('produtos-dropdown');
    const contatoTrigger = document.querySelector('[data-contato-trigger]');
    const contatoDropdown = document.getElementById('contato-dropdown');

    if (!header) return;

    const swiperMenuProducts = new Swiper('.swiper-menu-products', {
        slidesPerView: 2,
        spaceBetween: 32,
        freeMode: true,
        loop: true,

        navigation: {
            nextEl: '.arrows-container .arrow-next',
            prevEl: '.arrows-container .arrow-prev',
        },
        breakpoints: {
            1200: {
                slidesPerView: 3,
            }
        }
    })

    // Scroll behavior - add scrolled class when scrolling
    function handleScroll() {
        if (window.scrollY > 10) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }
    }

    // Scroll to next section functionality
    function handleScrollArrowClick() {
        const scrollArrow = document.querySelector('.about-hero__scroll-arrow');

        if (scrollArrow) {
            scrollArrow.addEventListener('click', function() {
                // Find the next section after the hero
                const heroSection = document.querySelector('.about-hero');
                if (heroSection) {
                    const nextSection = heroSection.nextElementSibling;

                    if (nextSection) {
                        // Smooth scroll to the next section
                        nextSection.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    } else {
                        // If no next section, scroll to the breadcrumb or first available section
                        const breadcrumb = document.querySelector('.breadcrumb-nav');
                        const firstSection = document.querySelector('section:not(.about-hero)');
                        const targetElement = breadcrumb || firstSection;

                        if (targetElement) {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }
                }
            });
        }
    }

    // Mobile menu toggle
    function toggleMobileMenu() {
        mobileMenu.classList.toggle('mobile-menu--active');
        document.body.classList.toggle('overflow-hidden');

        // Update button icon
        const buttonIcon = mobileMenuButton.querySelector('svg');
        if (mobileMenu.classList.contains('mobile-menu--active')) {
            buttonIcon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>';
        } else {
            buttonIcon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>';
        }
    }

    // Close mobile menu
    function closeMobileMenu() {
        mobileMenu.classList.remove('mobile-menu--active');
        document.body.classList.remove('overflow-hidden');

        // Reset button icon
        const buttonIcon = mobileMenuButton.querySelector('svg');
        buttonIcon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>';
    }

    // Mobile dropdown toggle
    function toggleMobileDropdown(dropdown) {
        dropdown.classList.toggle('mobile-dropdown--active');
        const menu = dropdown.querySelector('.mobile-dropdown-menu');

        if (dropdown.classList.contains('mobile-dropdown--active')) {
            menu.classList.remove('hidden');
        } else {
            menu.classList.add('hidden');
        }
    }

    // Desktop dropdown toggle
    function toggleDesktopDropdown(dropdown) {
        // Close all other dropdowns first
        desktopDropdownToggles.forEach(toggle => {
            const otherDropdown = toggle.closest('.header__nav-dropdown');
            const otherMenu = otherDropdown.querySelector('.desktop-dropdown-menu');
            if (otherDropdown !== dropdown) {
                otherDropdown.classList.remove('desktop-dropdown--active');
                if (otherMenu) {
                    otherMenu.classList.remove('desktop-dropdown--active');
                }
            }
        });

        // Toggle current dropdown
        dropdown.classList.toggle('desktop-dropdown--active');
        const menu = dropdown.querySelector('.desktop-dropdown-menu');
        if (menu) {
            menu.classList.toggle('desktop-dropdown--active');
        }
    }

    // Close all desktop dropdowns
    function closeAllDesktopDropdowns() {
        desktopDropdownToggles.forEach(toggle => {
            const dropdown = toggle.closest('.header__nav-dropdown');
            const menu = dropdown.querySelector('.desktop-dropdown-menu');
            dropdown.classList.remove('desktop-dropdown--active');
            if (menu) {
                menu.classList.remove('desktop-dropdown--active');
            }
        });
    }

    // Toggle institucional dropdown
    function toggleInstitucionalDropdown() {
        if (institucionalDropdown.classList.contains('show')) {
            closeInstitucionalDropdown();
        } else {
            openInstitucionalDropdown();
        }
    }

        // Open institucional dropdown
    function openInstitucionalDropdown() {
        // Close all other dropdowns first
        closeAllDesktopDropdowns();
        closeProdutosDropdown();
        closeContatoDropdown();

        // Show institucional dropdown
        institucionalDropdown.classList.add('show');

        // Update button state
        institucionalTrigger.closest('.header__nav-dropdown').classList.add('desktop-dropdown--active');
    }

        // Close institucional dropdown
    function closeInstitucionalDropdown() {
        institucionalDropdown.classList.remove('show');

        // Update button state
        institucionalTrigger.closest('.header__nav-dropdown').classList.remove('desktop-dropdown--active');
    }

    // Toggle produtos dropdown
    function toggleProdutosDropdown() {
        if (produtosDropdown.classList.contains('show')) {
            closeProdutosDropdown();
        } else {
            openProdutosDropdown();
        }
    }

    // Open produtos dropdown
    function openProdutosDropdown() {
        // Close all other dropdowns first
        closeAllDesktopDropdowns();
        closeInstitucionalDropdown();
        closeContatoDropdown();

        // Show produtos dropdown
        produtosDropdown.classList.add('show');

        // Update button state
        produtosTrigger.closest('.header__nav-dropdown').classList.add('desktop-dropdown--active');
    }

    // Close produtos dropdown
    function closeProdutosDropdown() {
        produtosDropdown.classList.remove('show');

        // Update button state
        produtosTrigger.closest('.header__nav-dropdown').classList.remove('desktop-dropdown--active');
    }

    // Toggle contato dropdown
    function toggleContatoDropdown() {
        if (contatoDropdown && contatoDropdown.classList.contains('show')) {
            closeContatoDropdown();
        } else {
            openContatoDropdown();
        }
    }

    // Open contato dropdown
    function openContatoDropdown() {
        if (contatoDropdown && contatoTrigger) {
            // Close all other dropdowns first
            closeAllDesktopDropdowns();
            closeInstitucionalDropdown();
            closeProdutosDropdown();

            // Show contato dropdown
            contatoDropdown.classList.add('show');

            // Update button state
            contatoTrigger.closest('.header__nav-dropdown').classList.add('desktop-dropdown--active');
        }
    }

    // Close contato dropdown
    function closeContatoDropdown() {
        if (contatoDropdown && contatoTrigger) {
            contatoDropdown.classList.remove('show');

            // Update button state
            contatoTrigger.closest('.header__nav-dropdown').classList.remove('desktop-dropdown--active');
        }
    }

    // Set active navigation link
    function setActiveNavLink() {
        const currentPath = window.location.pathname;
        const navLinks = document.querySelectorAll('.nav-link');

        // navLinks.forEach(link => {
        //      const linkPath = new URL(link.href).pathname;
        //     if (linkPath === currentPath) {
        //         link.classList.add('nav-link--active');
        //     } else {
        //         link.classList.remove('nav-link--active');
        //     }
        // });
    }

    // Event listeners
    window.addEventListener('scroll', handleScroll);

    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', toggleMobileMenu);
    }

    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', closeMobileMenu);
    }

    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }

    // Desktop dropdown toggles
    desktopDropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const dropdown = toggle.closest('.header__nav-dropdown');
            toggleDesktopDropdown(dropdown);
        });
    });

    // Institucional dropdown trigger
    if (institucionalTrigger) {
        institucionalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleInstitucionalDropdown();
        });
    }

    // Produtos dropdown trigger
    if (produtosTrigger) {
        produtosTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleProdutosDropdown();
        });
    }

    // Contato dropdown trigger
    if (contatoTrigger) {
        contatoTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleContatoDropdown();
        });
    }

    // Mobile dropdown toggles
    mobileDropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const dropdown = toggle.closest('.header__mobile-nav-dropdown');
            toggleMobileDropdown(dropdown);
        });
    });

    // Close mobile menu when clicking on a link
    const mobileNavLinks = document.querySelectorAll('.header__mobile-nav-link');
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', closeMobileMenu);
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.header__nav-dropdown') && !e.target.closest('.header__institucional-dropdown') && !e.target.closest('.header__produtos-dropdown') && !e.target.closest('.header__contato-dropdown')) {
            closeAllDesktopDropdowns();
            closeInstitucionalDropdown();
            closeProdutosDropdown();
            closeContatoDropdown();
        }
    });

    // Close mobile menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            if (mobileMenu.classList.contains('mobile-menu--active')) {
                closeMobileMenu();
            }
            closeAllDesktopDropdowns();
            closeInstitucionalDropdown();
            closeProdutosDropdown();
            closeContatoDropdown();
        }
    });

    // Close mobile menu on resize to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) {
            closeMobileMenu();
        } else {
            // Close desktop dropdowns on mobile
            closeAllDesktopDropdowns();
            closeInstitucionalDropdown();
            closeProdutosDropdown();
            closeContatoDropdown();
        }
    });

    // Initialize
    handleScroll();
    setActiveNavLink();
    handleScrollArrowClick(); // Initialize scroll arrow listener
}
